/**
 * `POST /chat/conversations/{id}/report`, and what its answer means for the dialog: sent, refused
 * for the hourly limit (five an hour, a 429), or failed for any other reason.
 */

import { ApiError } from '~/shared/api/mutator';
import { postChatConversationsConversationIdReport } from '~/shared/api/generated/endpoints/chat/chat';

export const MAX_REPORT_REASON = 1_000;

export type ReportOutcome = 'sent' | 'rateLimited' | 'failed';

export async function reportConversation(conversationId: number, reason: string): Promise<ReportOutcome> {
  try {
    await postChatConversationsConversationIdReport(conversationId, {
      reason: reason.trim().slice(0, MAX_REPORT_REASON),
    });
    return 'sent';
  } catch (error) {
    return error instanceof ApiError && error.status === 429 ? 'rateLimited' : 'failed';
  }
}
